import { Stack, Typography } from '@mui/material';

import { BoxedIcon } from '@/components/display/Ribbon/BoxedIcon';
import { sumHoldingsGroupCurrentValue } from '@/modules/estate/EstateDirectHoldings/DirectHoldingsGroupContainer/DirectHoldingsGroupContainer.utils';
import { formatCurrencyNoDecimals } from '@/utils/formatting/currency';

import { useEstateHoldingsContext } from '../../contexts/estateHoldings.context';
import { EstateTrustEntityCard } from './EstateTrustEntityCard/EstateTrustEntityCard';
import {
  TRUST_CONTAINER_VARIANT_COLORS,
  TRUST_CONTAINER_VARIANT_ICON,
  TRUST_CONTAINER_VARIANT_TITLE,
  TrustContainerVariant,
} from './TrustContainer.types';
import { filterTrustsByVariant } from './TrustContainer.utils';

export interface TrustContainerProps {
  variant: TrustContainerVariant;
}

export function TrustContainer({ variant }: TrustContainerProps) {
  const { entities } = useEstateHoldingsContext();

  const trusts = filterTrustsByVariant(entities ?? [], variant);
  const title = TRUST_CONTAINER_VARIANT_TITLE[variant];
  const IconComponent = TRUST_CONTAINER_VARIANT_ICON[variant];
  const colors = TRUST_CONTAINER_VARIANT_COLORS[variant];

  const currentValue = sumHoldingsGroupCurrentValue(trusts);

  if (trusts.length === 0) {
    return null;
  }

  return (
    <Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap={1}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <BoxedIcon
            icon={IconComponent}
            sx={{
              backgroundColor: colors.backgroundColor,
            }}
            iconProps={{
              size: 24,
              color: colors.iconColor,
              strokeWidth: 1.67,
            }}
          />
          <Stack>
            <Typography variant="title-s" component="div">
              {title}
            </Typography>
            <Typography
              variant="body-xs"
              sx={{ fontSize: '12px' }}
              component="span"
            >
              {formatCurrencyNoDecimals(currentValue)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack gap={1} mt={2}>
        <EstateTrustEntityCard trusts={trusts} />
      </Stack>
    </Stack>
  );
}
